<template>
    <div class="user-resume-dialog">
      <el-dialog :visible.sync="showUserResumeFlag" :closeOnClickModal="true" :showClose="true" :width="'666px'"
                 :destroyOnClose="true" :appendToBody="true" :customClass="''" :before-close="hideUserResume">
        <div slot="title" class="title"><i class="el-icon-tickets"></i><span style="padding-left: 5px;">{{'简历预览'}}</span></div>
        <div class="user-resume">
          <div class="user-resume-item">
            <span class="user-resume-item-title">求职者：</span>
            <span class="user-resume-item-content">{{userResumeView['realName'] || userResumeView['userName']}}</span>
            <div class="clear"></div>
          </div>
          <div class="user-resume-item">
            <span class="user-resume-item-title">年龄：</span>
            <span class="user-resume-item-content">{{userResumeView['age']}}</span>
            <div class="clear"></div>
          </div>
          <div class="user-resume-item">
            <span class="user-resume-item-title">所投职位：</span>
            <span class="user-resume-item-content">{{userResume['positionName']}}</span>
            <div class="clear"></div>
          </div>
          <div class="user-resume-item">
            <span class="user-resume-item-title">工作年限：</span>
            <span class="user-resume-item-content">{{userResume['workingLife'] ? userResume['workingLife'] / 10 : '--'}}年</span>
            <div class="clear"></div>
          </div>
          <div class="user-resume-item">
            <span class="user-resume-item-title">学历：</span>
            <span class="user-resume-item-content">{{userResume['educationDict'] ? userResume['educationDict']['dictName'] : '--'}}</span>
            <div class="clear"></div>
          </div>
          <div class="user-resume-item">
            <span class="user-resume-item-title">求职状态：</span>
            <span class="user-resume-item-content">{{userResume['jobStatus'] ? userResume['jobStatus'] : '--'}}</span>
            <div class="clear"></div>
          </div>
          <div class="user-resume-item">
            <span class="user-resume-item-title">联系方式：</span>
            <span class="user-resume-item-content">{{userResume['phone'] ? userResume['phone'] : '--'}}</span>
            <div class="clear"></div>
          </div>
          <div class="user-resume-item">
            <span class="user-resume-item-title">个人优势：</span>
            <span class="user-resume-item-content">{{userResume['introduce'] ? userResume['introduce'] : '--'}}</span>
            <div class="clear"></div>
          </div>
          <div class="user-resume-item">
            <span class="user-resume-item-title">工作经历：</span>
            <span class="user-resume-item-content">
              <div v-for="(ex, index) of userResumeView['listJobExperiences']" :key="index" class="ex-item">
                <div>
                  <span class="company-name">{{ex['companyName']}}</span>
                  <span class="work-life">{{ex['startTime'] | dateFormat('YYYY.MM.DD')}}-{{ex['endTime'] | dateFormat('YYYY.MM.DD')}}</span>
                </div>
                <div>{{ex['content']}}</div>
              </div>
            </span>
            <div class="clear"></div>
          </div>
          <div class="user-resume-item">
            <span class="user-resume-item-title">教育经历：</span>
            <span class="user-resume-item-content">
              <div v-for="(ex, index) of userResumeView['listEducationExperience']" :key="index" class="ex-item">
                <div>
                  <span class="company-name">{{ex['schoolName']}}</span>
                  <span class="work-life">{{ex['startTime'] | dateFormat('YYYY.MM.DD')}}-{{ex['endTime'] | dateFormat('YYYY.MM.DD')}}</span>
                </div>
                <div>
                  <span class="edu-item">{{ex['category']}}</span>
                  <span class="edu-item">{{ex['experience']}}</span>
                  <span class="edu-item">{{ex['major']}}</span>
                </div>
              </div>
            </span>
            <div class="clear"></div>
          </div>
        </div>
        <div style="text-align: center;margin-top: 10px">
          <el-button size="small" type="primary" @click="hideUserResume">确定</el-button>
        </div>
      </el-dialog>
    </div>
</template>

<script>
export default {
  name: 'UserResume',
  props: ['showUserResumeFlag', 'userResume'],
  data () {
    return {
      userResumeView: this.userResume
    }
  },
  methods: {
    hideUserResume (done) {
      this.$emit('hideUserResume')
    }
  },
  created () {
    console.log(this.userResume)
    this.$http.get(this.$api.getResumeByUserCode.url, {userCode: this.userResume.userCode}).then(_ => {
      if (_ && _.code === 200) {
        this.userResumeView = _.data || this.userResume
      }
    })
  }
}
</script>

<style scoped>
  .title {
    font-size: 16px;
    font-weight: bold;
  }
.user-resume-item {
  margin-bottom: 5px;
}
.user-resume-item-title {
  width: 75px;
  display: inline-block;
  float: left;
  color: #313131;
  font-weight: bold;
}
.user-resume-item-content {
  width: calc(100% - 75px);
  display: inline-block;
  float: left;
}
  .clear {
    clear: both;
  }
  /deep/ .el-dialog__body {
    padding-top: 0;
  }
  .company-name {
    color: #313131;
    font-weight: bold;
    margin-right: 10px;
  }
  .work-life {
    color: #999999;
    font-size: 12px;
  }
  .ex-item {
    margin-bottom: 5px;
  }
  .edu-item {
    color: #999999;
    margin-right: 20px;
    position: relative;
  }
  .edu-item:not(:first-child)::before {
    position: absolute;
    content: '';
    height: 12px;
    width: 1px;
    background: #999999;
    top: 4px;
    left: -12px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Recruit/UserResume.vue